import { render, staticRenderFns } from "./contactUs.vue?vue&type=template&id=b56633de&scoped=true&"
import script from "./contactUs.vue?vue&type=script&setup=true&lang=js&"
export * from "./contactUs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./contactUs.vue?vue&type=style&index=0&id=b56633de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56633de",
  null
  
)

export default component.exports